import { useQuery } from '@apollo/client'
import { Autocomplete, TextField } from '@mui/material'
import { GetCollegesQuery } from '__generated__/graphql'
import { useState } from 'react'
import { GetColleges } from 'shared/graphql/colleges.gql'

interface SchoolFilterProps {
    collegeIds: string[]
    onChange: (collegeIds: string[]) => void
}

export function SchoolFilter({ collegeIds, onChange }: SchoolFilterProps) {
    const { data, loading } = useQuery(GetColleges)
    const [open, setOpen] = useState(false)

    const selectedColleges =
        data?.colleges?.filter((college) => collegeIds.includes(college.id)) ||
        []

    const handleCollegeChange = (
        _: any,
        selectedColleges: GetCollegesQuery['colleges']
    ) => {
        onChange(selectedColleges.map((college) => college.id))
    }

    return (
        <Autocomplete
            ChipProps={{ size: 'small' }}
            loading={loading}
            multiple
            value={selectedColleges}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={handleCollegeChange}
            options={data?.colleges || []}
            getOptionKey={(option) => option.id}
            getOptionLabel={(option) => option.value}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="College"
                    placeholder="Search Colleges..."
                />
            )}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={(event, reason) => {
                if (reason === 'blur') {
                    setOpen(false)
                }
            }}
        />
    )
}
